// Sugar Alarm — Cycle 457: "a hero's picture changed" as a local signal.
//
// The server fans a body-less `hero_roster_changed` frame (with the member
// id) to every socket that holds the member after a picture change commits.
// `useGlucoseSocket` hands it here; the Heroes list and the "Who's
// treating?" picker subscribe and re-fetch, so a kiosk shows a new picture
// within one WS round trip without a reload. A save made on THIS device
// signals here too, directly, so the device that made the change does not
// wait for its own frame.

import { useEffect, useState } from "react";

type Listener = (memberId: string | null) => void;

const listeners = new Set<Listener>();
let version = 0;

export function notifyHeroRosterChanged(memberId: string | null): void {
  version += 1;
  listeners.forEach((l) => {
    try {
      l(memberId);
    } catch {
      /* a listener's failure never stops the others */
    }
  });
}

export function subscribeHeroRoster(l: Listener): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

/** A counter that moves whenever any hero's picture changes (for `memberId`
 *  when given, else for any member). Put it in a fetch effect's deps. */
export function useHeroRosterVersion(memberId?: string | null): number {
  const [v, setV] = useState(version);
  useEffect(
    () =>
      subscribeHeroRoster((m) => {
        if (memberId == null || m == null || m === memberId) setV((x) => x + 1);
      }),
    [memberId],
  );
  return v;
}
